"use client";
// The signed-in workspace: dashboard layout (sidebar + header); signed-out users go to /login.
import { useAuth } from "context/UseContext";
import DashboardLayout from "layouts/Dashboard";
import { Navigate, OutletProvider } from "lib/router";

export default function Layout({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  return (
    <OutletProvider outlet={children}>
      <DashboardLayout />
    </OutletProvider>
  );
}
